import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useFetch, useApiClient } from '@marageti/z4-lib';
import { SalesRecording } from '@marageti/z4-sdk/lib/travel';
import RepeatReferralDetailsView from './repeat-referral-details-view';

const RepeatReferralDetailsContainer = () => {
  const apiClient = useApiClient();
  const { repeatReferralId } = useParams();

  const { data: repeatReferral, isLoading, error } = useFetch<SalesRecording>(apiClient.salesRecordingsClient.getSalesRecording, [repeatReferralId], true);

  if (error?.code === 404) {
    return <Navigate to="/sales/monthly" replace />;
  }

  return (
    <RepeatReferralDetailsView
      isLoading={isLoading}
      repeatReferral={repeatReferral}
    />
  );
};

export default RepeatReferralDetailsContainer;
